import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

const SalaryHistoryModal = ({
  showSalaryHistoryModal,
  setShowSalaryHistoryModal,
  selectedEmployee,
  historyLoading,
  salaryHistory,
  newSalary,
  setNewSalary,
  handleAddSalary
}) => {
  return (
    <Dialog open={showSalaryHistoryModal} onOpenChange={setShowSalaryHistoryModal}>
      <DialogContent className="max-w-2xl" data-testid="salary-history-modal">
        <DialogHeader>
          <DialogTitle>Maaş Geçmişi - {selectedEmployee?.name}</DialogTitle>
          <DialogDescription>
            Başlangıç Maaşı: {selectedEmployee?.starting_salary || 0} TL | 
            Güncel Maaş: {selectedEmployee?.current_salary || 0} TL
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="rounded-md border max-h-[300px] overflow-y-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Geçerlilik Tarihi</TableHead>
                  <TableHead>Maaş Tutarı</TableHead>
                  <TableHead>Açıklama</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {historyLoading ? (
                  <TableRow>
                    <TableCell colSpan={3} className="text-center py-4">Yükleniyor...</TableCell>
                  </TableRow>
                ) : salaryHistory.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} className="text-center py-4 text-slate-500">Maaş değişikliği bulunmuyor</TableCell>
                  </TableRow>
                ) : (
                  salaryHistory.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{new Date(item.effective_date).toLocaleDateString('tr-TR')}</TableCell>
                      <TableCell>{item.amount.toLocaleString('tr-TR')} TL</TableCell>
                      <TableCell>{item.reason || '-'}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </div>

          <form onSubmit={handleAddSalary} className="space-y-4 mt-6 p-4 bg-slate-50 rounded-lg border">
            <h4 className="font-semibold text-sm">Yeni Maaş Girişi</h4>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Yeni Maaş Tutarı (TL)</Label>
                <Input 
                  type="number" 
                  min="0"
                  required 
                  value={newSalary.amount}
                  onChange={(e) => setNewSalary({...newSalary, amount: e.target.value})}
                />
              </div>
              <div className="space-y-2">
                <Label>Geçerlilik Tarihi</Label>
                <Input 
                  type="date" 
                  required 
                  value={newSalary.effective_date}
                  onChange={(e) => setNewSalary({...newSalary, effective_date: e.target.value})}
                />
              </div>
              <div className="space-y-2 col-span-2">
                <Label>Açıklama / Sebep</Label>
                <Input 
                  value={newSalary.reason}
                  placeholder="Örn: Yıllık Zam, Terfi vs."
                  onChange={(e) => setNewSalary({...newSalary, reason: e.target.value})}
                />
              </div>
            </div>
            <Button type="submit" className="w-full">Maaşı Güncelle</Button>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SalaryHistoryModal;